function __initHubUpsellModal() {
  var modal = document.getElementById('HubUpsellModal');
  if (!modal) return;

  var SESSION_KEY = 'hub-upsell-dismissed';
  var pendingCheckoutTarget = null;

  if (modal.dataset.hubInCart === 'true') {
    sessionStorage.setItem(SESSION_KEY, '1');
  }

  function shouldShow() {
    if (sessionStorage.getItem(SESSION_KEY)) return false;
    if (modal.dataset.isHubMember === 'true') return false;
    return true;
  }

  function openModal() {
    modal.style.setProperty('--m-opacity', '1');
    modal.classList.add('m-open-modal');
    document.documentElement.classList.add('prevent-scroll');
  }

  function closeModal() {
    modal.classList.remove('m-open-modal');
    modal.style.setProperty('--m-opacity', '0');
    document.documentElement.classList.remove('prevent-scroll');
  }

  function proceedToCheckout() {
    sessionStorage.setItem(SESSION_KEY, '1');
    closeModal();
    if (pendingCheckoutTarget) {
      pendingCheckoutTarget.click();
    }
  }

  // Intercept checkout button clicks (capture phase, fires before NDIS)
  document.addEventListener('click', function(e) {
    var target = e.target.closest('button[name="checkout"]');
    if (!target) return;
    if (!shouldShow()) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    pendingCheckoutTarget = target;
    openModal();
  }, true);

  // Intercept form submissions (cart page)
  document.addEventListener('submit', function(e) {
    var form = e.target;
    var checkoutBtn = form.querySelector('button[name="checkout"]');
    if (!checkoutBtn) return;
    if (!shouldShow()) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    pendingCheckoutTarget = checkoutBtn;
    openModal();
  }, true);

  // Click outside modal content to dismiss
  modal.addEventListener('click', function(e) {
    if (e.target === modal) {
      sessionStorage.setItem(SESSION_KEY, '1');
      closeModal();
    }
    e.stopPropagation();
  });

  // Close button
  var closeBtn = modal.querySelector('.hub-upsell-modal__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      sessionStorage.setItem(SESSION_KEY, '1');
      closeModal();
    });
  }

  // Dismiss button — continue to checkout
  var dismissBtn = modal.querySelector('.hub-upsell-modal__dismiss');
  if (dismissBtn) {
    dismissBtn.addEventListener('click', proceedToCheckout);
  }

  // Sign up button — dismiss, close modal and cart drawer before navigating
  var signupBtn = modal.querySelector('.hub-upsell-modal__signup-btn');
  if (signupBtn) {
    signupBtn.addEventListener('click', function() {
      sessionStorage.setItem(SESSION_KEY, '1');
      closeModal();
      var drawer = document.querySelector('m-cart-drawer');
      if (drawer && typeof drawer.close === 'function') {
        drawer.close();
      }
    });
  }
}
